import { Assertions } from '@/lib/assert';
import type { Directive } from 'vue';

const onScrollSymbol = Symbol('on-scroll-symbol');
const callbackSymbol = Symbol('callback-symbol');

export const onScrollEnd: Directive<HTMLElement, () => unknown> & {
  [onScrollSymbol]: (e: Event) => void;
  [callbackSymbol]: null | (() => unknown);
} = {
  get [onScrollSymbol]() {
    return (e: Event) => {
      const element = e.target as HTMLElement;
      Assertions.defined(element, 'e.target in `onScrollEnd` directive');
      if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
        this[callbackSymbol]?.();
      }
    };
  },

  [callbackSymbol]: null,

  get mounted() {
    return (el: HTMLElement, { value }: { value: () => unknown }) => {
      this[callbackSymbol] = value;
      el.addEventListener('scroll', this[onScrollSymbol]);
    };
  },

  get beforeUnmount() {
    return (el: HTMLElement) => {
      el.removeEventListener('scroll', this[onScrollSymbol]);
    };
  },
};
